import { render, staticRenderFns } from "./ProductSearchTab.vue?vue&type=template&id=29f11f98"
import script from "./ProductSearchTab.vue?vue&type=script&lang=js"
export * from "./ProductSearchTab.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchTab.vue?vue&type=style&index=0&id=29f11f98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports